import React from "react";
import Box from "@mui/material/Box";
import ComparedSalesIncNetSalesExcTax from "./ComparedSalesIncTaxNetSalesExcTax";
import ComparedSalesByTender from "./ComparedSalesByTender";
import ComparedNetMarginLocation from "./ComparedNetMarginByLocation";
import ComparedNetSalesByLocation from "./ComparedNetSalesByLocation";
import ComparedSalesInsightAreaSales from "./CompareSalesInsightAreaSales";
import ComparedSalesByProduct from "./ComparedSalesByProduct";
import ComparedNetMarginExcTax from "./ComparedNetMargin";
import ComparedNetMarginRate from "./ComparedNetMarginRate";
import ComparedNetMarginExcTaxByProduct from "./ComparedNetMarginExcTaxByProduct";


const ComparedSalesOverviewDashboard = () => (
    <Box sx={{ width: '100%', flexGrow: 1, height: 'auto' }}>
        <Box sx={{ marginY: '20px', display: 'flex', flexDirection: 'row', height: 'auto' }}>
            <Box  sx={{ width: '25%' }}>
                <ComparedSalesInsightAreaSales />
            </Box>
            <Box sx={{ width: '75%' }}>
                <ComparedSalesByProduct />
            </Box>
        </Box>
        <Box sx={{ width: 'auto', marginY: '20px' }}>
            <ComparedSalesIncNetSalesExcTax />
        </Box>
        <Box sx={{ width: 'auto', marginY: '20px' }}>
            <ComparedNetMarginExcTax />
        </Box>
        <Box sx={{ width: 'auto', marginY: '20px'}}>
            <ComparedNetMarginRate />
        </Box>
        <Box sx={{ width: 'auto', marginY: '20px'}}>
            <ComparedSalesByTender />
        </Box>
        <Box sx={{ width: 'auto', marginY: '20px' }}>
            <ComparedNetMarginLocation />
        </Box>
        <Box sx={{ width: 'auto', marginY: '20px' }}>
            <ComparedNetMarginExcTaxByProduct />
        </Box>
        <Box sx={{ width: 'auto', marginY: '20px' }}>
            <ComparedNetSalesByLocation />
        </Box>
    </Box>
);

export default ComparedSalesOverviewDashboard;
